import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';
import fonts from '../../../../utils/Fonts';

const behaviourFields = [
  {
    label: 'Panel Action',
    name: 'action',
    editor: 'dropdown',
    default: '',
    description: 'An action to run when this panel is clicked',
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    name: 'panelTitleWithContent',
    label: 'Include Title with Content',
    description: '',
    editor: 'switch',
    type: 'boolean',
    default: 'justify-center',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  }
];

const contentFields = [
  {
    label: 'Data Binding Source',
    name: 'datasourceId',
    description: 'Choose a content type this element will get its data from',
    editor: 'dropdown',
    function: {
      name: 'getDynamicDataSources',
      params: ['app.id']
    },
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    name: 'title',
    label: 'Title',
    description: '',
    editor: 'textbox',
    type: 'string',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    name: 'text',
    label: 'Text',
    description: '',
    editor: 'textarea',
    type: 'string',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  }
];

const colorFields = [
  {
    name: 'color',
    label: 'Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#ffffff',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'titleColor',
    label: 'Title Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#000000',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Border Color',
    name: 'borderColor',
    editor: 'color',
    description: 'The border color of a list item',
    default: '#182fa4',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'backgroundColor',
    label: 'Background Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#ffffff',
    displayWhen: [
      {
        field: 'showBackgroundImage',
        operator: 'DOES_NOT_EQUAL',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  }
];

const layoutFields = [
  'margin',
  {
    name: 'padding',
    label: 'Padding',
    description: '',
    editor: 'boundary',
    type: 'string',
    default: '10 10 10 10',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  'alignment',
  {
    label: 'Width',
    name: 'width',
    editor: 'number',
    description: 'The width of the button',
    default: 245,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    name: 'height',
    label: 'Height',
    description: '',
    editor: 'number',
    type: 'string',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    name: 'panelTitleAlignment',
    label: 'Title Alignment',
    description: '',
    editor: 'alignment',
    type: 'string',
    default: 'justify-center',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    name: 'panelTextAlignment',
    label: 'Panel Text Alignment',
    description: '',
    editor: 'alignment',
    type: 'string',
    default: 'justify-center',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    name: 'titlePadding',
    label: 'Title Padding',
    description: '',
    editor: 'boundary',
    type: 'string',
    default: '10 10 10 10',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Border Radius',
    name: 'borderRadius',
    editor: 'number',
    description: 'The border radius of the element',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Border Width',
    name: 'borderWidth',
    editor: 'number',
    description: 'The border width of the element',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  'layout'
];

const fontFields = [
  'font',
  {
    name: 'fontTitle',
    label: 'Title Font',
    description: '',
    editor: 'fontsize',
    type: 'string',
    default: 'justify-center',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    name: 'titleFontFamily',
    label: 'Title Font Family',
    description: '',
    editor: 'dropdown',
    options: [{ label: '<Not Set>', value: '' }, ...fonts],
    type: 'string',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    name: 'contentFontFamily',
    label: 'Content Font Family',
    description: '',
    editor: 'dropdown',
    options: [{ label: '<Not Set>', value: '' }, ...fonts],
    type: 'string',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  }
];

const imageFields = [
  {
    label: 'Hide Title Icon',
    name: 'hideTitleIcon',
    editor: 'boolean',
    default: false,
    description: 'If the title icon should be hidden',
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Title Icon',
    name: 'titleIconName',
    editor: 'textbox',
    default: 'pencil-outline',
    description: 'A material icon name',
    displayWhen: [{ field: 'hideTitleIcon', operator: '===', value: false }],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Show Background Image',
    name: 'showBackgroundImage',
    editor: 'boolean',
    default: false,
    description: 'If the button should include an icon',
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    name: 'backgroundImage',
    label: 'Background Image',
    description: '',
    editor: 'image',
    mediaLibraryStoreIn: 'custom_folder',
    mediaLibraryPath: 'apps',
    type: 'string',
    default: '#182fa4',
    displayWhen: [{ field: 'showBackgroundImage', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  }
];

const PanelElementFields = {
  group: ELEMENT_GROUPS.LAYOUTS,
  disableAdd: false,
  label: 'Panel',
  icon: 'ViewColumnsIcon',
  description: 'Add a panel that contains a group of items',
  properties: [
    ...behaviourFields,
    ...contentFields,
    ...fontFields,
    ...layoutFields,
    ...imageFields,
    ...colorFields
  ]
};

export default PanelElementFields;
